var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showType == 'form-builder')?_c('b-form-group',{style:(_vm.properties.style),attrs:{"description":_vm.properties.description,"label":_vm.properties.label}},[_c('div',{staticClass:"d-flex flex-row justify-content-start align-items-center"},[_c('v-select',{staticClass:"w-25"}),_c('v-select',{staticClass:"w-25"}),_c('span',{staticClass:"ml-1 mr-1"},[_vm._v("for")]),_c('v-select',{staticClass:"w-25"})],1)]):_vm._e(),(_vm.showType == 'properties')?_c('div',[_c('frequency-duration-v1-properties',{attrs:{"formId":_vm.formId}})],1):_vm._e(),(
      _vm.showType == 'form-submitter' ||
        (_vm.showType == 'e-form' && _vm.properties.eFormEditable)
    )?_c('b-form-group',{staticStyle:{"font-size":"14px"},style:(_vm.properties.style),attrs:{"description":_vm.computedConditions.description
        ? _vm.superComputeFormSubmitterValue({
            elementId: this.id,
            property: 'description',
            value: _vm.properties.description,
            defaultValue: '',
            form: this.form
          })
        : _vm.properties.description,"label":_vm.computedConditions.label
        ? _vm.superComputeFormSubmitterValue({
            elementId: this.id,
            property: 'label',
            value: _vm.properties.label,
            defaultValue: '',
            form: this.form
          })
        : _vm.properties.label,"hidden":_vm.computedHidden,"state":_vm.state,"invalid-feedback":_vm.errors.join(', ')}},[_c('div',{staticClass:"d-flex flex-row justify-content-start align-items-center"},[_c('v-select',{staticClass:"w-25",staticStyle:{"font-size":"14px"},attrs:{"options":_vm.computedConditions.frequencyFirstOptions
            ? _vm.superComputeFormSubmitterValue({
                elementId: this.id,
                property: 'frequencyFirstOptions',
                value: _vm.properties.frequencyFirstOptions,
                defaultValue: [],
                form: this.form
              })
            : _vm.properties.frequencyFirstOptions},model:{value:(_vm.frequencyFirstValue),callback:function ($$v) {_vm.frequencyFirstValue=$$v},expression:"frequencyFirstValue"}}),_c('v-select',{staticClass:"w-25",staticStyle:{"font-size":"14px"},attrs:{"options":_vm.computedConditions.frequencySecondOptions
            ? _vm.superComputeFormSubmitterValue({
                elementId: this.id,
                property: 'frequencySecondOptions',
                value: _vm.properties.frequencySecondOptions,
                defaultValue: [],
                form: this.form
              })
            : _vm.properties.frequencySecondOptions},model:{value:(_vm.frequencySecondValue),callback:function ($$v) {_vm.frequencySecondValue=$$v},expression:"frequencySecondValue"}}),_c('span',{staticClass:"ml-1 mr-1"},[_vm._v("for")]),_c('v-select',{staticClass:"w-25",staticStyle:{"font-size":"14px"},attrs:{"options":_vm.computedConditions.durationOptions
            ? _vm.superComputeFormSubmitterValue({
                elementId: this.id,
                property: 'durationOptions',
                value: _vm.properties.durationOptions,
                defaultValue: [],
                form: this.form
              })
            : _vm.properties.durationOptions},model:{value:(_vm.durationValue),callback:function ($$v) {_vm.durationValue=$$v},expression:"durationValue"}})],1)]):_vm._e(),(
      _vm.showType == 'form-viewer' ||
        (_vm.showType == 'e-form' && !_vm.properties.eFormEditable)
    )?_c('b-form-group',{attrs:{"label":_vm.computedConditions.label
        ? _vm.superComputeFormSubmitterValue({
            elementId: this.id,
            property: 'label',
            value: _vm.properties.label,
            defaultValue: '',
            form: this.form
          })
        : _vm.properties.label}},[_vm._v(" "+_vm._s(_vm.controlValue)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }